export class ClassicReportData {
  chartLabels: string[];
  chartData1: any[];
  chartData2: any[];
}
